<template>
    <ElementLayout :parent="parent" :element="element">
        &nbsp;
        <v-btn @click="run" color="primary" slot="right" style="margin:10px 0 10px 0">{{element.title}}</v-btn>
    </ElementLayout>
</template>

<script>
import ElementLayout from '../ElementLayout' 
import CurrencyBox from '../../ui-elements/CurrencyBox'
import CodeHelpers from '../../helpers/CodeHelpers'

export default {
    data() {
        return {
        
        }
    },

    components: {
        ElementLayout,
        CurrencyBox,
    },
    
    props: {
        element: Object,
        parent: Object,
    },

    computed: {
        attributes() {

        }
    },

    methods: {
        run_copy_element_attribute() {
            console.log('copying attribute...')
        }, 
        run() {
            const buttonName = this.element.name
            CodeHelpers[buttonName]()
        },
    },
}
</script>

<style scoped>
   
</style>




// WEBPACK FOOTER //
// ButtonControl.vue?48398726